import { render, staticRenderFns } from "./ShareRecordingDialog.vue?vue&type=template&id=1044e7c8&scoped=true"
import script from "./ShareRecordingDialog.vue?vue&type=script&lang=js"
export * from "./ShareRecordingDialog.vue?vue&type=script&lang=js"
import style0 from "./ShareRecordingDialog.vue?vue&type=style&index=0&id=1044e7c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1044e7c8",
  null
  
)

export default component.exports